// utils/impersonation.ts

// Basic email shape check - intentionally simple; full RFC validation is not the goal.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isImpersonationLogin(email: string): boolean {
  return typeof email === "string" && email.includes("|");
}

/**
 * Parse "ssaEmail|targetEmail" into normalized emails.
 * Splits on the FIRST pipe only. Returns null if either half is not a valid email
 * (callers must treat null as a generic auth failure - no enumeration).
 */
export function parseImpersonationLogin(
  email: string,
): { ssaEmail: string; targetEmail: string } | null {
  const idx = email.indexOf("|");
  if (idx === -1) return null;
  const ssaEmail = email.slice(0, idx).trim().toLowerCase();
  const targetEmail = email.slice(idx + 1).trim().toLowerCase();
  if (!EMAIL_RE.test(ssaEmail) || !EMAIL_RE.test(targetEmail)) return null;
  return { ssaEmail, targetEmail };
}
